export default __webpack_public_path__ + "static/media/DSC_0555.98266511.jpg";